import { render, staticRenderFns } from "./WaybillDetails.vue?vue&type=template&id=72ea98db&scoped=true&"
import script from "./WaybillDetails.vue?vue&type=script&lang=js&"
export * from "./WaybillDetails.vue?vue&type=script&lang=js&"
import style0 from "./WaybillDetails.vue?vue&type=style&index=0&id=72ea98db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea98db",
  null
  
)

export default component.exports